// extracted by mini-css-extract-plugin
module.exports = {"bubble":"Bubble_bubble__enBli","skeletonPill":"Bubble_skeletonPill__zpWnV"};